/**
 * Search: Businesses and Leaders tabs beside Discussions, Posts and Tags. One request answers both
 * (voucha-community/search): businesses by name, description, services or products; current governors and LGA
 * chairpersons by name, state or LGA ("kano governor", "ikeja chairman").
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
const results = new Map(); // query -> { businesses, leaders }
const pending = new Map();
function fetchResults(query) {
  const q = query.toLowerCase().trim();
  if (results.has(q)) return Promise.resolve(results.get(q));
  if (!pending.has(q)) {
    pending.set(q, app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/voucha-community/search?limit=6&q=' + encodeURIComponent(q),
      errorHandler: () => {}
    }).catch(() => ({
      businesses: [],
      leaders: []
    })).then(r => {
      results.set(q, {
        businesses: r && r.businesses || [],
        leaders: r && r.leaders || []
      });
      pending.delete(q);
      m.redraw();
      return results.get(q);
    }));
  }
  return pending.get(q);
}
const initials = n => String(n || '?').split(/\s+/).slice(0, 2).map(w => w[0] || '').join('').toUpperCase();
class Source {
  constructor(key, title) {
    this.resource = key;
    this.key = key;
    this.label = title;
  }
  title() {
    return this.label;
  }
  isCached(query) {
    return results.has(query.toLowerCase().trim());
  }
  search(query) {
    return fetchResults(query);
  }
  list(query) {
    const r = results.get(query.toLowerCase().trim());
    return r && r[this.key] || [];
  }
  customGrouping() {
    return false;
  }
  fullPage() {
    return null;
  }
}
class BusinessesSource extends Source {
  constructor() {
    super('businesses', 'Businesses');
  }
  view(query) {
    return this.list(query).map(b => m("li", {
      className: "VSearchResult",
      "data-index": 'businesses' + b.slug,
      "data-id": b.slug
    }, m(Link, {
      href: '/businesses/' + b.slug,
      className: "VSearchResult-link"
    }, b.logoUrl ? m("img", {
      className: "VSearchResult-pic",
      src: b.logoUrl,
      alt: ""
    }) : m("span", {
      className: "VSearchResult-pic is-initials"
    }, initials(b.name)), m("span", {
      className: "VSearchResult-text"
    }, m("span", {
      className: "VSearchResult-name"
    }, b.name, b.verified ? m("i", {
      className: "fas fa-circle-check VSearchResult-tick",
      "aria-label": "Verified"
    }) : null), m("span", {
      className: "VSearchResult-desc"
    }, [b.category, b.place].filter(Boolean).join(' · '))))));
  }
  gotoItem(id) {
    return '/businesses/' + id;
  }
}
class LeadersSource extends Source {
  constructor() {
    super('leaders', 'Leaders');
  }
  view(query) {
    return this.list(query).map((l, i) => m("li", {
      className: "VSearchResult",
      "data-index": 'leaders' + i,
      "data-id": String(i)
    }, m(Link, {
      href: l.url || '/data-hub/states',
      className: "VSearchResult-link"
    }, l.photo ? m("img", {
      className: "VSearchResult-pic is-round",
      src: l.photo,
      alt: "",
      onerror: e => e.target.replaceWith(Object.assign(document.createElement('span'), {
        className: 'VSearchResult-pic is-round is-initials',
        textContent: initials(l.name)
      }))
    }) : m("span", {
      className: "VSearchResult-pic is-round is-initials"
    }, initials(l.name)), m("span", {
      className: "VSearchResult-text"
    }, m("span", {
      className: "VSearchResult-name"
    }, l.name), m("span", {
      className: "VSearchResult-desc"
    }, [l.role + ', ' + l.place, l.party].filter(Boolean).join(' · '))))));
  }
  gotoItem(id) {
    const l = this.list(app.search && app.search.getValue ? app.search.getValue() : '')[Number(id)];
    return l ? l.url : null;
  }
}
export default function registerSearch() {
  extend('flarum/forum/components/GlobalSearch', 'sourceItems', function (items) {
    if (!app.forum.attribute('canViewForum')) return;
    items.add('vouchaBusinesses', new BusinessesSource(), -20);
    items.add('vouchaLeaders', new LeadersSource(), -30);
  });
}